// src/types/auth/PermissionSlug.ts
var PermissionSlug = /* @__PURE__ */ ((PermissionSlug2) => {
  PermissionSlug2["Wildcard"] = "*";
  PermissionSlug2["PropertiesCreate"] = "properties.create";
  PermissionSlug2["PropertiesList"] = "properties.list";
  PermissionSlug2["PropertiesView"] = "properties.view";
  PermissionSlug2["PropertiesUpdate"] = "properties.update";
  PermissionSlug2["PropertiesDelete"] = "properties.delete";
  PermissionSlug2["PropertiesPublish"] = "properties.publish";
  PermissionSlug2["ExperiencesCreate"] = "experiences.create";
  PermissionSlug2["ExperiencesList"] = "experiences.list";
  PermissionSlug2["ExperiencesView"] = "experiences.view";
  PermissionSlug2["ExperiencesUpdate"] = "experiences.update";
  PermissionSlug2["ExperiencesDelete"] = "experiences.delete";
  PermissionSlug2["ExperiencesPublish"] = "experiences.publish";
  PermissionSlug2["ServicesCreate"] = "services.create";
  PermissionSlug2["ServicesList"] = "services.list";
  PermissionSlug2["ServicesView"] = "services.view";
  PermissionSlug2["ServicesUpdate"] = "services.update";
  PermissionSlug2["ServicesDelete"] = "services.delete";
  PermissionSlug2["ServicesPublish"] = "services.publish";
  PermissionSlug2["BookingsView"] = "bookings.view";
  PermissionSlug2["BookingsCreate"] = "bookings.create";
  PermissionSlug2["BookingsApprove"] = "bookings.approve";
  PermissionSlug2["BookingsReject"] = "bookings.reject";
  PermissionSlug2["BookingsCancel"] = "bookings.cancel";
  PermissionSlug2["GuestDocumentsView"] = "guest_documents.view";
  PermissionSlug2["ReservationsView"] = "reservations.view";
  PermissionSlug2["ReservationsCreate"] = "reservations.create";
  PermissionSlug2["ReservationsUpdate"] = "reservations.update";
  PermissionSlug2["ReservationsCancel"] = "reservations.cancel";
  PermissionSlug2["FinanceViewPayouts"] = "finance.view_payouts";
  PermissionSlug2["FinanceRequestPayout"] = "finance.request_payout";
  PermissionSlug2["FinanceAddPaymentMethod"] = "finance.add_payment_method";
  PermissionSlug2["FinanceViewTransactions"] = "finance.view_transactions";
  PermissionSlug2["FinanceViewBilling"] = "finance.view_billing";
  PermissionSlug2["FinanceManageBilling"] = "finance.manage_billing";
  PermissionSlug2["FinanceSettleDebt"] = "finance.settle_debt";
  PermissionSlug2["WorkspaceViewMembers"] = "workspace.view_members";
  PermissionSlug2["WorkspaceInviteMembers"] = "workspace.invite_members";
  PermissionSlug2["WorkspaceManageMembers"] = "workspace.manage_members";
  PermissionSlug2["WorkspaceViewRoles"] = "workspace.view_roles";
  PermissionSlug2["WorkspaceManageRoles"] = "workspace.manage_roles";
  PermissionSlug2["WorkspaceAssignPermissions"] = "workspace.assign_permissions";
  PermissionSlug2["WorkspaceViewInvitations"] = "workspace.view_invitations";
  PermissionSlug2["WorkspaceSettings"] = "workspace.settings";
  PermissionSlug2["VerificationView"] = "verification.view";
  PermissionSlug2["VerificationSubmit"] = "verification.submit";
  PermissionSlug2["PbacAssignUsers"] = "pbac.assign_users";
  PermissionSlug2["PbacManageGroups"] = "pbac.manage_groups";
  PermissionSlug2["PbacViewGroups"] = "pbac.view_groups";
  PermissionSlug2["ChatRead"] = "chat.read";
  PermissionSlug2["ChatWrite"] = "chat.write";
  PermissionSlug2["AutomatedMessagesView"] = "automated_messages.view";
  PermissionSlug2["AutomatedMessagesManage"] = "automated_messages.manage";
  PermissionSlug2["PricingView"] = "pricing.view";
  PermissionSlug2["PricingManage"] = "pricing.manage";
  PermissionSlug2["BookingRulesView"] = "booking_rules.view";
  PermissionSlug2["BookingRulesManage"] = "booking_rules.manage";
  PermissionSlug2["CalendarView"] = "calendar.view";
  PermissionSlug2["CalendarManage"] = "calendar.manage";
  PermissionSlug2["FrontDeskCheckIn"] = "front_desk.check_in";
  PermissionSlug2["FrontDeskCheckOut"] = "front_desk.check_out";
  PermissionSlug2["FrontDeskNoShow"] = "front_desk.no_show";
  PermissionSlug2["RoomsAssign"] = "rooms.assign";
  PermissionSlug2["HousekeepingView"] = "housekeeping.view";
  PermissionSlug2["HousekeepingUpdate"] = "housekeeping.update";
  PermissionSlug2["HousekeepingInspect"] = "housekeeping.inspect";
  PermissionSlug2["HousekeepingAssign"] = "housekeeping.assign";
  PermissionSlug2["ReportsView"] = "reports.view";
  PermissionSlug2["CouponsView"] = "coupons.view";
  PermissionSlug2["CouponsManage"] = "coupons.manage";
  PermissionSlug2["TravelGuidesView"] = "travel_guides.view";
  PermissionSlug2["TravelGuidesManage"] = "travel_guides.manage";
  PermissionSlug2["DeveloperView"] = "developer.view";
  PermissionSlug2["DeveloperManage"] = "developer.manage";
  return PermissionSlug2;
})(PermissionSlug || {});

export {
  PermissionSlug
};
